import React, { Component } from "react";
import classes from "./SearchBar.module.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../../store/actions/index";
import Spinner from "../../Spinner/Spinner";
import { removeSpecialChars, string_to_slug } from "../../../store/utility";
class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.searchlist = React.createRef();
  }
  state = {
    suggestions: [],
    value: "",
    webinars: [],
    loading: false,
  };

  filterSuggestions = (searchKeys, value) => {
    let suggestions = searchKeys.filter((sug) => {
      // return sug.toLowerCase().slice(0, value.length).match(value);
      sug = sug.replace(/-+/g, " ");
      return sug.toLowerCase().match(value);
    });
    this.setState({ suggestions });
  };

  getSuggestions = async (e) => {
    try {
      if (this.searchlist.current) {
        this.searchlist.current.style.visibility = "visible";
      }
      let value = e.target.value.toLowerCase();
      if (value.trim() == "") {
        return this.setState({ suggestions: [], value });
      }
      this.setState({ value: value });
      if (!this.props.searchKeys) {
        let searchKeys = await this.props.fetchSearchKeys();
        this.filterSuggestions(searchKeys, value);
      } else {
        this.filterSuggestions(this.props.searchKeys, value);
      }
    } catch (error) {}
  };

  handleSearchClick = (suggestion) => {
    if (this.searchlist.current) {
      this.searchlist.current.style.visibility = "hidden";
    }

    if (suggestion) {
      suggestion = suggestion.replace(/-+/g, " ");
      // alert(suggestion);
      this.props.history.push(
        `/search/${this.state.value}/${string_to_slug(suggestion)}`
      );
      this.setState({ value: suggestion });
    } else {
      if (string_to_slug(removeSpecialChars(this.state.value.trim()))) {
        this.props.history.push(
          `/search/${string_to_slug(this.state.value)}/results`
        );
      }
    }
  };
  componentDidMount = () => {
    let { searchKey, suggestion } = this.props.match.params;
    if (suggestion !== "results" && suggestion) {
      this.setState({ value: suggestion.replaceAll("-", " ") });
    } else {
      if (searchKey) {
        this.setState({ value: searchKey.replaceAll("-", " ") });
      }
    }
  };
  getSearchDisplayPermission = () => {
    let perm = false;
    if (!this.props.searchLoading) {
      perm = true;
    } else {
    }
    if (this.state.value == "") {
      perm = false;
    }
    return perm;
  };
  // componentDidUpdate = ()=>{
  //   let {searchKey,suggestion} = this.props.match.params
  //   console.log(searchKey,suggestion)
  // }
  render() {
    // if(this.props.searchLoading){
    //   return <Spinner/>
    // }
    return (
      <div className={classes.SearchDiv}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            this.handleSearchClick(null);
          }}
        >
          <input
            type="text"
            className="form-control"
            placeholder="Search Products"
            onChange={this.getSuggestions}
            value={this.state.value}
          />
          <div className="flex-column">
            {this.getSearchDisplayPermission() ? (
              <ul
                className={`list-group ${classes.SearchList}`}
                ref={this.searchlist}
              >
                {this.state.suggestions.map((sug) => (
                  <li
                    className={`list-group-item ${classes.SearchListItem}`}
                    key={sug}
                    onClick={() => this.handleSearchClick(sug)}
                  >
                    {sug.replace(/-+/g, " ")}
                  </li>
                ))}
              </ul>
            ) : (
              <div
                className={classes.SearchList}
                style={{ height: this.state.value ? "150px" : "0px" }}
              >
                {this.state.value && <Spinner />}
              </div>
            )}
          </div>
        </form>
        {/* <div className={classes.BackDrop}></div> */}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    searchKeys: state.homeProducts.searchKeys,
    searchLoading: state.homeProducts.searchLoading,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchSearchKeys: () => dispatch(actions.fetchSearchKeys()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SearchBar));
